import { MenuItem } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';

import FigmaChartIcon from 'components/Icons/FigmaChartIcon';
import FigmaKpiIcon from 'components/Icons/FigmaKpiIcon';
import FigmaTableIcon from 'components/Icons/FigmaTableIcon';
import FigmaVarianceIcon from 'components/Icons/FigmaVarianceIcon';
import { getSelectedPage } from 'redux/DashboardSliceV2';
import { font, neutral, text as textToken } from 'styles/revampTokens';

export interface Properties {
  onSelectInstrument: (instrument: string) => void;
  flags?: any;
}

// Same row shape as components/ActionMenuList — bg/hover/padding here match
// it prop-for-prop so this dropdown and the block card's 3-dot menu don't
// drift into two different menu styles the way they had before.
const ITEM_STYLES = {
  bg: neutral.surface,
  borderRadius: 0,
  padding: '9px 11px',
  gap: '8px',
  fontFamily: font.body,
  fontSize: '13px',
  color: textToken.primary,
  _hover: { bg: neutral.surfaceHover },
};

const InstrumentMenuList = ({ flags, onSelectInstrument }: Properties) => {
  const selectedPage = useSelector(getSelectedPage);

  return (
    <>
      {selectedPage && (
        <>
          <MenuItem {...ITEM_STYLES} onClick={() => onSelectInstrument('kpi')}>
            <FigmaKpiIcon width={16} height={16} color='#121826' />
            KPI
          </MenuItem>
          <MenuItem {...ITEM_STYLES} onClick={() => onSelectInstrument('line')}>
            <FigmaChartIcon width={16} height={16} color='#121826' />
            Chart
          </MenuItem>
          <MenuItem {...ITEM_STYLES} onClick={() => onSelectInstrument('table')}>
            <FigmaTableIcon width={16} height={16} color='#121826' />
            Table
          </MenuItem>
          {flags?.dashboardVariance && (
            <MenuItem {...ITEM_STYLES} onClick={() => onSelectInstrument('variance')}>
              <FigmaVarianceIcon width={16} height={16} color='#121826' />
              Variance
            </MenuItem>
          )}
        </>
      )}
    </>
  );
};

export default withLDConsumer()(InstrumentMenuList);
